import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from '../../services';
import { BackButtonComponent } from '../back-button/back-button.component';
import { BreadcrumbsComponent } from '../breadcrumbs';

@Component({
    standalone: true,
    selector: 'app-handler-back-and-breadcrumb-button',
    templateUrl: './handler-back-and-breadcrumb-button.component.html',
    styleUrls: ['./handler-back-and-breadcrumb-button.component.scss'],
    imports: [BackButtonComponent, BreadcrumbsComponent],
})
export class HandlerBackAndBreadcrumbButtonComponent implements OnInit {
    public showBreadcrumb: boolean;

    @Input() url: string;
    @Input() color = 'primary';

    constructor(private configService: ConfigService) {}

    ngOnInit(): void {
        this.getConfiguration();
    }

    getConfiguration(): void {
        this.showBreadcrumb = this.configService.showBreadcrumbs();
    }
}
